import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { computed, defineComponent, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash/debounce";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { getActivePromocodeCampaigns } from "@/db/promocode-campaign";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import searchIcon from "@/assets/images/svg/search.svg";
import { removeCodePayment } from "@/utils/vue-helpers/promocode";
import BookingModule from "@/store/modules/booking";
import { LogLevel, LogService } from "@/services/logging";
import ModalModule from "@/store/modules/modal";
export default defineComponent({
  name: ModalComponents.PromocodeCampaigns,
  setup: function setup() {
    var _useI18n = useI18n(),
        t = _useI18n.t;

    var modalVisibility = dialogVisibleForStatus(ModalStatus.PromocodeCampaigns);
    var promocodeCampaigns = ref([]);
    var groupedCards = ref({});
    var searchQuery = ref("");
    var isLoading = ref(false);
    var error = ref(null);
    var appliedCodes = computed(function () {
      return BookingModule.appliedPromocodes;
    });

    function fetchPromocodeCampaigns() {
      return _fetchPromocodeCampaigns.apply(this, arguments);
    } // we need to show campaigns in alphabetical order, and we need to group them by the first letter of their name


    function _fetchPromocodeCampaigns() {
      _fetchPromocodeCampaigns = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
                _context.prev = 1;
                isLoading.value = true;
                error.value = null;
                _context.next = 6;
                return getActivePromocodeCampaigns({
                  pinnedOnly: false,
                  searchTerm: query
                });

              case 6:
                promocodeCampaigns.value = _context.sent;
                updateCardsList();
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                LogService.info("Error when fetching promocode campaigns from DexieDB", {
                  params: {
                    error: _context.t0
                  }
                }, LogLevel.Error);

              case 13:
                _context.prev = 13;
                isLoading.value = false;
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10, 13, 16]]);
      }));
      return _fetchPromocodeCampaigns.apply(this, arguments);
    }

    function groupCardsByName(cards) {
      var grouped = {};

      var _iterator = _createForOfIteratorHelper(cards),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;
          var firstLetter = c.name.charAt(0).toUpperCase();

          if (!grouped[firstLetter]) {
            grouped[firstLetter] = [];
          }

          grouped[firstLetter].push(c);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return grouped;
    }

    function toggleApplyPromocode(_x) {
      return _toggleApplyPromocode.apply(this, arguments);
    }

    function _toggleApplyPromocode() {
      _toggleApplyPromocode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!data.isApplied) {
                  _context2.next = 3;
                  break;
                }

                // the promocode is already applied, let's remove it
                removeCodePayment(data.code);
                return _context2.abrupt("return");

              case 3:
                ModalModule.setModalProps({
                  props: data
                });
                ModalModule.setStatus(ModalStatus.PromocodeCampaignsTickets);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _toggleApplyPromocode.apply(this, arguments);
    }

    function updateCardsList() {
      // get all applied codes
      var cards = promocodeCampaigns.value.map(function (campaign) {
        var code = campaign.codes[0];
        var isApplied = appliedCodes.value.find(function (c) {
          return c.promocode.code === code;
        });
        return {
          id: campaign.id,
          code: code,
          name: campaign.name,
          picture: campaign.picture,
          flatValue: campaign.flatValue,
          percentageValue: campaign.percentageValue,
          isApplied: !!isApplied
        };
      }); // group cards alphabetically

      groupedCards.value = groupCardsByName(cards);
    }

    var debouncedFetchCampaigns = debounce(fetchPromocodeCampaigns, 300);
    watch(searchQuery, function (newQuery) {
      debouncedFetchCampaigns(newQuery);
    });
    fetchPromocodeCampaigns();
    watch(appliedCodes, function () {
      updateCardsList();
    });
    return {
      t: t,
      modalVisibility: modalVisibility,
      searchQuery: searchQuery,
      isLoading: isLoading,
      searchIcon: searchIcon,
      groupedCards: groupedCards,
      toggleApplyPromocode: toggleApplyPromocode
    };
  }
});